






































import { computed, defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "DocumentPreview",
  components: { BaseIconButton, BaseIcon },
  props: {
    size: { type: [String, Number], default: "122px" },
    alt: { type: String },
    loading: { type: Boolean, default: false },
    remove: { type: Boolean, default: false },
  },
  setup(props) {
    const styleSize = computed(() => {
      return typeof props.size === "number" ? `${props.size}px` : props.size;
    });
    return {
      styleSize,
    };
  },
});
